// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26H2q","col":"styles_col__sLd5S"};